
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// AGGRESSIIVINEN redirectit ja blokkaukset parempaa Google-näkyvyyttä varten
const redirectMap: Record<string, string> = {
  // Legacy loan product URLs
  '/asuntolaina': '/lainat/asuntolaina',
  '/kulutusluotto': '/lainat/kulutusluotto', 
  '/pikalaina': '/lainat/kulutusluotto',
  '/joustoluotto': '/lainat/kulutusluotto',
  '/autolaina': '/lainat/autolaina',
  '/venelaina': '/lainat/venelaina',
  '/mokkilaina': '/lainat/mokkilaina',
  '/remonttilaina': '/lainat/remonttilaina',
  '/energialaina': '/lainat/remonttilaina',
  '/caravanrahoitus': '/lainat/caravanrahoitus',
  '/moottoripyoralaina': '/lainat/moottoripyoralaina',
  '/pienkonelaina': '/lainat/pienkonelaina',
  '/haalaina': '/lainat/haalaina',
  '/yhdistelylaina': '/lainat/yhdistelylaina',
  '/yrityslaina': '/lainat/yrityslaina',
  '/lomalaina': '/lainat/lomalaina',
  
  // Common legacy redirects
  '/tietoa-meista': '/meista',
  '/tuotteet': '/lainatuotteet',
  '/asiakaspalvelu': '/yhteystiedot',
  '/ulosotto': '/lainat/ulosottolaskuri',
  '/ulosottolaskuri': '/lainat/ulosottolaskuri'
};

// BLOKKAA VAIN virhe- ja admin-sivut - EI vieraskielisiä sivuja
const blockedPathPatterns = [
  // Virhe- ja 404-sivut
  /^\/404($|\/)/,
  /^\/virhe($|\/)/,
  /^\/error($|\/)/,
  /404/,
  /error/,
  
  // Admin ja turvallisuus
  /^\/admin($|\/)/,
  /^\/wp-admin($|\/)/,
  /^\/api($|\/)/
];

interface NotFoundRedirectProps {
  path?: string;
}

const NotFoundRedirect = ({ path }: NotFoundRedirectProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = path || location.pathname;
  
  useEffect(() => {
    // BLOKKAA VAIN virhe- ja admin-sivut
    const isBlockedPath = blockedPathPatterns.some(pattern => 
      pattern.test(currentPath)
    );
    
    if (isBlockedPath) {
      console.log(`🚫 BLOCKED PATH: ${currentPath} - redirecting to home for better SEO`);
      navigate('/', { replace: true });
      return;
    }
    
    // Handle precise legacy redirects
    if (redirectMap[currentPath]) {
      console.log(`📍 REDIRECTING: ${currentPath} -> ${redirectMap[currentPath]}`);
      navigate(redirectMap[currentPath], { replace: true });
      return;
    }
    
    // Handle trailing slashes
    if (currentPath.endsWith('/') && currentPath.length > 1) {
      const pathWithoutSlash = currentPath.slice(0, -1);
      navigate(pathWithoutSlash, { replace: true });
      return;
    }

    // Handle capitalization errors
    const lowercasePath = currentPath.toLowerCase();
    if (lowercasePath !== currentPath) {
      navigate(lowercasePath, { replace: true });
      return;
    }
  }, [currentPath, navigate]);
  
  return null;
};

export default NotFoundRedirect;
